import { render, staticRenderFns } from "./ring-group-icon.vue?vue&type=template&id=147b0173"
import script from "./ring-group-icon.vue?vue&type=script&lang=js"
export * from "./ring-group-icon.vue?vue&type=script&lang=js"
import style0 from "./ring-group-icon.vue?vue&type=style&index=0&id=147b0173&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports